import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AFEducationHistoryDomain } from '../model/af.model';
import { AuthService } from './auth.service';
import { DateFormatPipe } from './dateFormatPipe';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class EducationService {

  constructor(private userService: AuthService, private http: HttpClient, private dt: DateFormatPipe) {
  }

  getEducationHistory(): Observable<AFEducationHistoryDomain> {
    return this.http.post<AFEducationHistoryDomain>(environment.api_uri + 'getEducationHistory', { 'verifyId': this.userService.getVerifyId() })
      .pipe(
        map(response => {
          response.educationList.forEach(item => {
            if (item.graduationDate) {
              if (item.graduationDate) {
                item.graduationDate = new Date(item.graduationDate);
              }
            }

            if (item.educationStartDate) {
              if (item.educationStartDate) {
                item.educationStartDate = new Date(item.educationStartDate);
              }
            }
            if (item.educationEndDate) {
              if (item.educationEndDate) {
                item.educationEndDate = new Date(item.educationEndDate);
              }
            }

            if (item.degreeType) {
              item.degreeType = item.degreeType + "";
            }
            if (item.educationInstitutionUsState) {
              item.educationInstitutionUsState = item.educationInstitutionUsState + "";
            }

            if (item.educationInstitutionType) {
              item.educationInstitutionType = item.educationInstitutionType + "";
            }

            if (item.educationInstitutionCountry) {
              item.educationInstitutionCountry = item.educationInstitutionCountry + "";
            }


          });
          return response;
        }));
  }



  submitEducationHistory(AFEducationHistoryDomain): Observable<AFEducationHistoryDomain> {
    const requestUrl = environment.api_uri + 'saveEducation';

    AFEducationHistoryDomain.educationList.forEach(item => {
      if (item.graduationDate) {
        if (item.graduationDate) {
          item.graduationDate = moment(item.graduationDate).format('MM/DD/YYYY');
        }
      }
      if (item.educationEndDate) {
        if (item.educationEndDate) {
          item.educationEndDate = moment(item.educationEndDate).format('MM/DD/YYYY');
        }
      }
      if (item.educationStartDate) {
        if (item.educationStartDate) {
          item.educationStartDate = moment(item.educationStartDate).format('MM/DD/YYYY');
        }
      }


    });

    return this.http.post<AFEducationHistoryDomain>(requestUrl, AFEducationHistoryDomain);
  }

  removeEducationHisAttachment(ousAttachmentID: string): Observable<string> {
    const requestUrl = environment.api_uri + 'removeEducationHisAttachment';
    const fd = {
      'verifyId': this.userService.getVerifyId(),
      'ousAttachmentID': ousAttachmentID
    }
    return this.http.post<string>(requestUrl, fd);
  }
}



